// ===================================================
// HEADER SCRIPT
// ===================================================
document.addEventListener('DOMContentLoaded', function () {

  // Hamburger menu click - toggle slide-down menu
  const menuBtn = document.querySelector('.mobile-topbar__menu');
  const mobileMenu = document.getElementById('mobileMenu');

  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', function () {
      mobileMenu.classList.toggle('is-open');
      menuBtn.classList.toggle('is-active');
    });
  }

  // Site Search Overlay - opens from header search icon (desktop + mobile)
  const searchOpenBtns = document.querySelectorAll('.js-search-open');
  const searchOverlay = document.getElementById('siteSearchOverlay');
  const searchCloseBtn = document.getElementById('siteSearchClose');
  const searchOverlayInput = document.getElementById('siteSearchInput');

  function openSiteSearch() {
    if (!searchOverlay) return;
    if (mobileMenu && mobileMenu.classList.contains('is-open')) {
      mobileMenu.classList.remove('is-open');
      if (menuBtn) menuBtn.classList.remove('is-active');
    }
    searchOverlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      if (searchOverlayInput) searchOverlayInput.focus();
    }, 300);
  }

  function closeSiteSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  searchOpenBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openSiteSearch();
    });
  });

  if (searchCloseBtn) {
    searchCloseBtn.addEventListener('click', closeSiteSearch);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('is-active')) {
      closeSiteSearch();
    }
  });

  // ---------------------------------------------------
  // NEW AND POPULAR - Tabs
  // ---------------------------------------------------
  const npTabs = document.querySelectorAll('.np-tab');
  const npGridEl = document.getElementById('npGrid');

  npTabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      if (tab.classList.contains('is-active')) return;

      npTabs.forEach(function (t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');

      if (npGridEl) {
        npGridEl.classList.add('is-switching');
        setTimeout(function () {
          const cards = Array.from(npGridEl.children);
          for (let i = cards.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [cards[i], cards[j]] = [cards[j], cards[i]];
          }
          cards.forEach(function (card) {
            npGridEl.appendChild(card);
          });
          npGridEl.classList.remove('is-switching');
        }, 250);
      }
    });
  });

  // ---------------------------------------------------
  // NEW AND POPULAR - Draggable product slider
  // ---------------------------------------------------
  const npGrid = document.getElementById('npGrid');
  if (npGrid) {
    let npIsDown = false;
    let npStartX;
    let npScrollStart;
    let npIsDragging = false;

    npGrid.addEventListener('mousedown', function (e) {
      npIsDown = true;
      npIsDragging = false;
      npGrid.classList.add('is-dragging');
      npStartX = e.pageX - npGrid.offsetLeft;
      npScrollStart = npGrid.scrollLeft;
    });

    window.addEventListener('mouseup', function () {
      npIsDown = false;
      npGrid.classList.remove('is-dragging');
    });

    npGrid.addEventListener('mouseleave', function () {
      npIsDown = false;
      npGrid.classList.remove('is-dragging');
    });

    npGrid.addEventListener('mousemove', function (e) {
      if (!npIsDown) return;
      e.preventDefault();
      npIsDragging = true;
      const x = e.pageX - npGrid.offsetLeft;
      const walk = (x - npStartX) * 1.2;
      npGrid.scrollLeft = npScrollStart - walk;
    });

    npGrid.addEventListener('click', function (e) {
      if (npIsDragging) {
        e.preventDefault();
        npIsDragging = false;
      }
    });
  }

});

/* ── C24 Size Picker + Add to Cart ── */
(function () {
  'use strict';

  function c24OpenCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (typeof drawer.open === 'function') {
      drawer.open();
    } else {
      drawer.classList.add('is-open', 'active');
      var inner = drawer.querySelector('#CartDrawer');
      if (inner) inner.classList.add('is-open', 'active');
      document.body.classList.add('overflow-hidden');
    }
  }

  function c24UpdateCartCount(count) {
    document.querySelectorAll(
      '.cart-count, .CartCount, [data-cart-count], .c24-cart-count, ' +
      '.cart-count-bubble, .cart-icon-bubble span, #CartCount, ' +
      '.header__cart .count'
    ).forEach(function (el) {
      el.textContent = count;
    });
    var drawerTitle = document.querySelector('cart-drawer h4');
    if (drawerTitle) {
      drawerTitle.innerHTML = drawerTitle.innerHTML.replace(/\(\d+\)/, '(' + count + ')');
    }
  }

  function c24RefreshAndOpen() {
    c24OpenCartDrawer();

    fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newItems = doc.querySelector('#CartDrawer-CartItems');
        var oldItems = document.querySelector('#CartDrawer-CartItems');
        if (newItems && oldItems) oldItems.innerHTML = newItems.innerHTML;

        var newFooter = doc.querySelector('.minicartTol');
        var oldFooter = document.querySelector('.minicartTol');
        if (newFooter && oldFooter) oldFooter.innerHTML = newFooter.innerHTML;

        var newHeader = doc.querySelector('cart-drawer h4');
        var oldHeader = document.querySelector('cart-drawer h4');
        if (newHeader && oldHeader) oldHeader.innerHTML = newHeader.innerHTML;

        var newShip = doc.querySelector('.freeShipMsg');
        var oldShip = document.querySelector('.freeShipMsg');
        if (newShip && oldShip) oldShip.outerHTML = newShip.outerHTML;

        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl) drawerEl.classList.remove('is-empty');

        var drawerItems = document.querySelector('cart-drawer-items');
        if (drawerItems) drawerItems.classList.remove('hide');

        var drawerFooter = document.querySelector('.minicartTol');
        if (drawerFooter) drawerFooter.classList.remove('hide');

        var emptyDiv = document.querySelector('.drawer-empty');
        if (emptyDiv) emptyDiv.classList.add('hide');

        if (window.lazySizes) window.lazySizes.init();
      })
      .catch(function (e) {
        console.warn('C24 cart refresh error:', e);
      });

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        c24UpdateCartCount(cart.item_count);
      });
  }

  function c24SizeInit() {

    // ── Size pill click ──
    document.querySelectorAll('.size-item.size-available').forEach(function (pill) {
      if (pill.dataset.c24bound) return;
      pill.dataset.c24bound = '1';

      pill.addEventListener('click', function (e) {
        e.stopPropagation();
        var productId = pill.dataset.productId;
        document.querySelectorAll('#sizes-' + productId + ' .size-item').forEach(function (s) {
          s.classList.remove('selected', 'c24-pulse');
        });
        pill.classList.add('selected');
        pill.classList.add('c24-pulse');
        setTimeout(function () { pill.classList.remove('c24-pulse'); }, 600);
      });

      pill.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          pill.click();
        }
      });
    });

    // ── Add to Cart button ──
    document.querySelectorAll('[data-c24-atc]').forEach(function (btn) {
      if (btn.dataset.c24bound) return;
      btn.dataset.c24bound = '1';

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var productId = btn.dataset.productId;
        var selectedPill = document.querySelector('#sizes-' + productId + ' .size-item.selected');

        if (!selectedPill) {
          var sizesEl = document.getElementById('sizes-' + productId);
          if (sizesEl) {
            sizesEl.classList.remove('c24-shake');
            void sizesEl.offsetWidth;
            sizesEl.classList.add('c24-shake');
            sizesEl.querySelectorAll('.size-item.size-available').forEach(function (s) {
              s.classList.add('c24-pulse');
              setTimeout(function () { s.classList.remove('c24-pulse'); }, 600);
            });
            setTimeout(function () { sizesEl.classList.remove('c24-shake'); }, 500);
          }
          return;
        }

        var variantId = selectedPill.dataset.variantId;
        var originalHtml = btn.innerHTML;

        btn.innerHTML = '<span style="display:inline-block;width:18px;height:18px;border:2px solid #fff;border-top-color:transparent;border-radius:50%;animation:c24-spin .6s linear infinite;vertical-align:middle;"></span>';
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            btn.innerHTML = originalHtml;
            btn.disabled = false;
            return;
          }

          c24RefreshAndOpen();

          btn.innerHTML = '<i class="at at-check" aria-hidden="true"></i><span> Added!</span>';
          setTimeout(function () {
            btn.innerHTML = originalHtml;
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          btn.innerHTML = originalHtml;
          btn.disabled = false;
        });
      });
    });
  }

  // Global expose — subcat-pills AJAX ke baad reinit ke liye
  window.__c24SizeInit = c24SizeInit;

  if (!document.getElementById('c24-spin-style')) {
    var st = document.createElement('style');
    st.id = 'c24-spin-style';
    st.textContent = '@keyframes c24-spin{to{transform:rotate(360deg)}}';
    document.head.appendChild(st);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', c24SizeInit);
  } else {
    c24SizeInit();
  }

  document.addEventListener('shopify:section:load', c24SizeInit);
  document.addEventListener('cart24:products-loaded', c24SizeInit);

})();